import React, { useState } from "react";
import Widget from "./Widget";
import {
  SubTitle,
  InfoWrapper,
  InfoList,
  EditContainer,
} from "./Widget.styled";
import { useStore } from "../../../../../hooks";
import { observer } from "mobx-react-lite";
import Spinner from "../../../../../components/common/Spinner";
import CheckIcon from "./CheckIcon";
import NoDataAvailable from "./NoDataAvailable";
import SaveSingleContactModal from "../../../../../elements/v2/SaveSingleContactModal/SaveSingleContactModal";
import { useUserCheckPermissions } from "../../../../../hooks/useUserCheckPermissions";
import { PermissionCodes } from "../../../../../utils/enums";

const GeneralInfo = observer(() => {
  const [initialData, setInitialData] = useState({});
  const [isOpeningEditModal, setIsOpeningEditModal] = useState(false);
  const { unifiedCustomerProfileStore, authStore, contactStore } = useStore();
  const [createContactModal, setCreateContactModal] = useState(false);
  const { checkPermission } = useUserCheckPermissions();

  const contactInfo = unifiedCustomerProfileStore.contactInfo[0] || {};

  // [DEPRECATED_GRAPHQL] - Para eliminación: contactStore.getSingleContact usa GraphQL query getSingleContact
  // TODO: Eliminar después de verificar que nuevas APIs funcionan correctamente
  
  // const getSingleContactData = async () => {
  //   try {
  //     const customer = authStore.selectedAccount.id;
  //     const { contact_id } = contactInfo;
  //     const response = await contactStore.getSingleContact(
  //       customer,
  //       String(contact_id)
  //     );
  //     const data = JSON.parse(response.data.getSingleContact.body);
  //     const formattedData = {
  //       parameters: {
  //         contact_id: contact_id ? contact_id : "",
  //         full_name: data.full_name,
  //         company_name: data.company_name,
  //         email_addresses: typeof data.email_addresses === 'string' ? 
  //           JSON.parse(data.email_addresses) : data.email_addresses,
  //         phone_numbers: typeof data.phone_numbers === 'string' ? 
  //           JSON.parse(data.phone_numbers) : data.phone_numbers,
  //         addresses: typeof data.addresses === 'string' ? 
  //           JSON.parse(data.addresses) : data.addresses,
  //       },
  //     };
  //     setInitialData(formattedData);
  //     setCreateContactModal(true);
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  // const openEditSingleContact = async () => {
  //   setIsOpeningEditModal(true);
  //   if (!contactStore.isLoading) {
  //     await getSingleContactData();
  //     setIsOpeningEditModal(false);
  //   }
  // };

  return (
    <>

      <SaveSingleContactModal
        createContactModal={createContactModal}
        setCreateContactModal={setCreateContactModal}
        initialData={initialData}
      />
      <Widget
        title="Contact Info"
        height={Object.keys(contactInfo).length === 0 ? "auto" : "360px"}
        actions={
          // [DEPRECATED_GRAPHQL] - Para eliminación: openEditSingleContact usa contactStore.getSingleContact
          // TODO: Eliminar después de verificar que nuevas APIs funcionan correctamente
          
          // checkPermission(PermissionCodes.UCP_CONTACT_INFO, "UPDATE") && (
          //   <EditContainer 
          //     isLoading={isOpeningEditModal} 
          //     onClick={openEditSingleContact} 
          //     disabled={unifiedCustomerProfileStore.isLoading || Object.keys(contactInfo).length === 0}
          //   >
          //     Edit
          //   </EditContainer>
          // )
          null
        }
      >
        {unifiedCustomerProfileStore.isLoading ? (
          <Spinner />
        ) : (
          <InfoWrapper>
            {Object.keys(contactInfo).length === 0 ? (
              <NoDataAvailable />
            ) : (
              <InfoList>
                <li>
                  <SubTitle>Name:</SubTitle>
                  <span>{contactInfo.contact_full_name}</span>
                </li>
                <li>
                  <SubTitle>Phone number:</SubTitle>
                  <span>{contactInfo.contact_phone_number}</span>
                </li>
                <li>
                  <SubTitle>Email:</SubTitle>
                  <span>{contactInfo.contact_email}</span>
                </li>
                <li>
                  <SubTitle>State:</SubTitle>
                  <span>{contactInfo.contact_state}</span>
                </li>
                <li>
                  <SubTitle>City:</SubTitle>
                  <span>{contactInfo.contact_city}</span>
                </li>
                <li>
                  <SubTitle>Address:</SubTitle>
                  <span>{contactInfo.contact_address}</span>
                </li>
                <li>
                  <SubTitle>Company name:</SubTitle>
                  <span>{contactInfo.contact_company_name}</span>
                </li>
                <li>
                  <SubTitle>Postal code:</SubTitle>
                  <span>{contactInfo.contact_postal_code}</span>
                </li>
                <li>
                  <SubTitle>Email Allow:</SubTitle>
                  <CheckIcon value={contactInfo.do_not_email} />
                </li>
                <li>
                  <SubTitle>Call Allow:</SubTitle>
                  <CheckIcon value={contactInfo.do_not_call} />
                </li>
                <li>
                  <SubTitle>Mail Allow:</SubTitle>
                  <CheckIcon value={contactInfo.do_not_mail} />
                </li>
              </InfoList>
            )}
          </InfoWrapper>
        )}
      </Widget>
    </>
  );
});

export default GeneralInfo;
